(() => {
  function setup(root = document) {
    root.querySelectorAll('[data-dh-slider]').forEach(slider => {
      if (slider.dataset.ready) return;
      slider.dataset.ready = 'true';
      const track = slider.querySelector('[data-dh-track]');
      const prev = slider.querySelector('[data-dh-prev]');
      const next = slider.querySelector('[data-dh-next]');
      if (!track || !prev || !next) return;
      const update = () => {
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      const move = direction => track.scrollBy({
        left: direction * track.clientWidth,
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
      prev.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, { passive: true });
      track.addEventListener('keydown', event => {
        if (event.target !== track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          move(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
      new ResizeObserver(update).observe(track);
      update();
    });
  }
  setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
